import { React, classNames, defaultMessages, hooks } from 'jimu-core';
import { styled } from 'jimu-theme';
import { CloseOutlined } from 'jimu-icons/outlined/editor/close';
import { Button } from './button';
const TagRoot = styled.div `
  width: 100%;
  > ul.choices-data-list {
    width: 100%;
    text-align: left;
    padding: 0;
    margin: 0;
    list-style: none;
  }
`;
const TagItem = styled.li `
  display: inline-flex;
  list-style: none;
  max-width: calc(100% - 6px);
  padding: 4px 8px;
  line-height: 1.125rem;
  background: var(--sys-color-primary-dark);
  color: var(--ref-palette-black);
  border-radius: 2px;
  margin-right: 6px;
  margin-bottom: 6px;
  > .text {
    flex-grow: 1;
  }
  > .delete {
    flex-shrink: 0;
    display: inline-block;
    margin-left: 6px;
    cursor: pointer;
  }
`;
const TagCaret = styled(Button) `
    flex-shrink: 0;
    padding: 0px !important;
    margin-left: 6px;
`;
/**
 * A component used to display tags.
 */
export const _Tag = (props) => {
    const { className, data, onChange } = props;
    const translate = hooks.useTranslation(defaultMessages);
    const handleDeleteLabel = (e, index) => {
        e.stopPropagation();
        const newData = [...data];
        newData.splice(index, 1);
        onChange === null || onChange === void 0 ? void 0 : onChange(newData);
    };
    return (React.createElement(TagRoot, { className: classNames('jimu-tag', className) }, data.length > 0 && React.createElement("ul", { className: 'choices-data-list' }, data.map((el, index) => {
        return (React.createElement(TagItem, { key: index, tabIndex: 0, "aria-label": el, role: 'button' },
            React.createElement("span", { className: 'text text-truncate', title: el }, el),
            React.createElement(TagCaret, { className: 'delete', type: 'tertiary', icon: true, size: 'sm', title: translate('delete'), "aria-label": translate('delete'), onClick: (e) => { handleDeleteLabel(e, index); } },
                React.createElement(CloseOutlined, { size: 's' }))));
    }))));
};
/**
 * A component used to display tags.
 */
export const Tag = _Tag;
